/**
 * Statistics displayed in the Home page Stats section.
 * `value` is the target number the count-up animation counts to.
 */
const stats = [
  { id: "years", value: 18, suffix: "+", label: "Years of Experience" },
  { id: "projects", value: 250, suffix: "+", label: "Projects Completed" },
  { id: "clients", value: 180, suffix: "+", label: "Happy Clients" },
  { id: "team", value: 45, suffix: "+", label: "Team Members" },
];

export default stats;